import { useMobileOrientation } from "react-device-detect";
import { Charts } from "shared/components";
import { isMobile } from "react-device-detect";

interface ComparisonBarChartProps {
  artistMetric: number;
  recommentation: number;
  labelColor?: string;
  color?: string[];
}
const ComparisonBarChart: React.FC<ComparisonBarChartProps> = ({
  artistMetric = 1,
  recommentation = 2,
  labelColor,
  color = ["#6998F7", "#68D9AC"],
}) => {
  const { isPortrait } = useMobileOrientation();

  return (
    <Charts.BarChart
      cor={color}
      min={0}
      max={5}
      horizontal={false}
      series={[{ data: [artistMetric] }, { data: [recommentation] }]}
      categories={[""]}
      yAxisFormatter={(val) => (val || 0).toPrecision(3)}
      containewWidth={!isMobile ? 300 : isPortrait ? 160 : 300}
      height={!isMobile ? 260 : isPortrait ? 140 : 160}
      defaultBarWidth={50}
      showX={false}
      labelColor={labelColor}
      showTooltip={false}
      showGridY
      legend={{
        show: false,
      }}
    />
  );
};

export default ComparisonBarChart;
